import ATECases from "./ATECases";
const BreachedATECases = () => {
  return (
    <div>
      <ATECases isBreached={true} />
    </div>
  );
};

export default BreachedATECases;